import * as tslib_1 from "tslib";
import { Injector } from '@angular/core';
import { TrackContextMenuComponent } from "../../tracks/track-context-menu/track-context-menu.component";
import { Player } from "../../player/player.service";
import { UserLibrary } from "../../users/user-library/user-library.service";
import { PlaylistService } from "../playlist.service";
import { Playlists } from "../playlists.service";
import { Lyrics } from "../../lyrics/lyrics.service";
var PlaylistTrackContextMenuComponent = /** @class */ (function (_super) {
    tslib_1.__extends(PlaylistTrackContextMenuComponent, _super);
    /**
     * PlaylistTrackContextMenuComponent Constructor.
     */
    function PlaylistTrackContextMenuComponent(player, userLibrary, injector, playlist, playlists, lyrics) {
        var _this = _super.call(this, player, userLibrary, injector, lyrics) || this;
        _this.player = player;
        _this.userLibrary = userLibrary;
        _this.injector = injector;
        _this.playlist = playlist;
        _this.playlists = playlists;
        _this.lyrics = lyrics;
        return _this;
    }
    /**
     * Remove track from currently active playlist.
     */
    PlaylistTrackContextMenuComponent.prototype.removeFromPlaylist = function () {
        this.playlists.removeTracks(this.data.playlistId, this.getTracks()).subscribe();
        this.contextMenu.close();
    };
    return PlaylistTrackContextMenuComponent;
}(TrackContextMenuComponent));
export { PlaylistTrackContextMenuComponent };
